import _ from 'lodash';
import store from '../store';
import { http, graphql } from '../utils/fetch';
import { IgnoreError, BadResponse } from './errors';

const AUTH_PATH = '/api/auth';
const LOGIN_URL = `${AUTH_PATH}/login`;
const REGISTER_URL = `${AUTH_PATH}/register`;
const USER_INFO_URL = `${AUTH_PATH}/user-info`;
const TOKEN_KEY = 'id_token';

function toUser(obj) {
  return _.pick(obj, ['id', 'username', 'firstName', 'lastName']);
}

function login(credentials) {
  return http.post(LOGIN_URL, credentials)
    .then((response) => {
      localStorage.setItem(TOKEN_KEY, response.data.token);
      store.commit('authenticated', true);
      store.commit('user', toUser(response.data));
      return true;
    })
    .catch((error) => {
      localStorage.removeItem(TOKEN_KEY);
      store.commit('authenticated', null);
      store.commit('user', null);

      if (error.response) {
        throw new BadResponse(error.response.data);
      }

      throw error;
    });
}

function logout() {
  // TODO close up the websocket
  // TODO
  // wsClient.unsubscribeAll();
  // wsClient.close();
  graphql.resetStore();
  store.commit('authenticated', false);
  store.commit('user', null);
  localStorage.removeItem(TOKEN_KEY);
}

function register(credentials) {
  logout();

  return http.post(REGISTER_URL, credentials)
    .then((response) => {
      localStorage.setItem(TOKEN_KEY, response.data.token);
      store.commit('authenticated', true);
      store.commit('user', toUser(response.data));
      return true;
    })
    .catch((error) => {
      if (error.response) {
        throw new BadResponse(error.response.data);
      }

      throw error;
    });
}

function getAuthToken() {
  // TODO
  // TODO
  // TODO
  // TODO
  // 2018-07-31 for some reason TOKEN_KEY is not working, but 'id_token' is???
  // return localStorage.getItem(TOKEN_KEY);
  return localStorage.getItem('id_token');
}

function getAuthHeader() {
  const header = {
    Authorization: '',
  };

  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    header.Authorization = `Bearer ${token}`;
  }

  return header;
}

function userInfo() {
  return http.get(USER_INFO_URL, { headers: getAuthHeader() })
    .then(response => response.data)
    .catch((error) => {
      if (error instanceof IgnoreError) {
        return Promise.resolve();
      }

      return Promise.reject(error);
    });
}

function checkAuthenticated() {
  if (localStorage.getItem(TOKEN_KEY)) {
    store.commit('authenticated', true);
  } else {
    store.commit('authenticated', false);
  }

  return store.getters.authenticated;
}

export {
  login,
  logout,
  register,
  userInfo,
  getAuthToken,
  getAuthHeader,
  checkAuthenticated,
};



// WEBPACK FOOTER //
// ./src/utils/auth.js